import type { FC } from 'react';
import { listDividerVariants } from './ListDivider.styles';
import type { ListDividerProp } from './ListDivider.types';

export const ListDivider: FC<ListDividerProp> = ({
  padded,
  size,
  className,
}) => <div className={listDividerVariants({ className, padded, size })} />;
